import React from "react";
import { useDesktopFilterPopover } from "../hooks/useDesktopFilterPopover";
import FilterSubmitFooter from "./FilterSubmitFooter";
export default function DesktopFilterPopover({ placement, trigger, children, onSubmit, }) {
    const { open, close, toggle, setReferenceEl, setPopperEl, styles, attributes, } = useDesktopFilterPopover(placement);
    function handleSubmit() {
        close();
        onSubmit();
    }
    return (<div className="shrink-0">
      {trigger({ ref: setReferenceEl, open, toggle })}

      {open ? (<div ref={setPopperEl} style={styles.popper} {...attributes.popper} className="bg-white shadow-[0_10px_20px_4px_rgba(29,41,61,0.15)] rounded-2xl w-[280px] z-50">
          <div className="p-4 overflow-y-auto [scrollbar-width:thin] [scrollbar-color:rgba(0,0,0,0.25)_transparent] [&::-webkit-scrollbar]:w-[5px] [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-black/25 [&::-webkit-scrollbar-thumb]:rounded-full" style={{ maxHeight: "min(400px, calc(100vh - 80px))" }}>
            {children}
          </div>
          <FilterSubmitFooter onSubmit={handleSubmit}/>
        </div>) : null}
    </div>);
}
